import { useEffect, useMemo, useState } from 'react';
import { homeAPI } from 'src/api/home-api';
import { OptionModel } from 'src/types/api-response';

export default function useCaySamFilterOptions() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [cameraOptions, setCameraOptions] = useState<OptionModel[]>([]);
  const [tinhTrangOptions, setTinhTrangOptions] = useState<OptionModel[]>([]);
  const [diemSucKhoeOptions, setDiemSucKhoeOptions] = useState<OptionModel[]>([]);
  const [tuoicayOptions, setTuoicayOptions] = useState<OptionModel[]>([]);
  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const [ tinhTrangRes, diemRes,tuoicayRes] = await Promise.all([
          
          homeAPI.OptionCaySamTinhTrang(),
          homeAPI.OptionCaySamDiemSucKhoe(),
          homeAPI.OptionLoSamLoaiTuoi(),
        ]);  

        if (isMounted) { 
            setTinhTrangOptions((tinhTrangRes.items ?? []) as any[])
            setDiemSucKhoeOptions(((diemRes.items ?? []) as any[]))
            setTuoicayOptions(((tuoicayRes.items ?? []) as any[]))
        }
      } catch (e: any) { 
        if (isMounted) setError(e?.message || 'Không thể tải tùy chọn lọc');
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, []);
  const getTuoiText = (tuoiId?: number) => {
    const found = tuoicayOptions.find((o) => Number(o.value) === Number(tuoiId));
    return found?.text || `ID: ${tuoiId}`;
  };
  const getTrangThaiText = (trangThaiId?: number) => {
    const found = tinhTrangOptions.find((o) => Number(o.value) === Number(trangThaiId));
    return found?.text || `ID: ${trangThaiId}`;
  };
  return {
    loading,
    error,
    cameraOptions,
    tinhTrangOptions,
    diemSucKhoeOptions,
    tuoicayOptions,
    getTuoiText,
    getTrangThaiText
  };
}


